import { Component, input } from '@angular/core';
import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { map, pipe, switchMap } from 'rxjs';
import { SimpleGridComponent } from '@app/shared/components/simple-grid/simple-grid.component';
import { RentalAgreementDetailsModel } from '../rental-agreements.model';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-rental-agreement-documents',
  standalone: true,
  imports: [SimpleGridComponent],
  templateUrl: './rental-agreement-documents.component.html',
  host: { class: 'd-flex flex-fill' }
})
export class RentalAgreementDocumentsComponent {
  rentalAgreement = input<RentalAgreementDetailsModel | null>(null);
  rentalAgreement$ = toObservable(this.rentalAgreement);

  listRentalAgreementDocumentsOperator = pipe(
    switchMap(() => this.rentalAgreement$),
    map((ra) => {
      if (!ra) return [];
      return [
        {
          documentType: 'Invoice',
          valueWithoutTax: ra.totalInvoice,
          taxValue: ra.totalInvoiceTaxValue,
          valueWithTax: ra.totalInvoiceWithTax
        },
        {
          documentType: 'Invoice (Cashier)',
          valueWithoutTax: ra.totalCashier,
          taxValue: ra.totalCashierTaxValue,
          valueWithTax: ra.totalCashierWithTax
        }
      ];
    })
  );

  columnDefs: ColDef[] = [
    {
      field: 'documentType',
      filter: false,
      floatingFilter: false
    },
    {
      field: 'valueWithoutTax',
      valueFormatter: (params: ValueFormatterParams) => {
        return (Math.round((params.value + Number.EPSILON) * 100) / 100).toString();
      },
      filter: false,
      floatingFilter: false
    },
    {
      field: 'taxValue',
      valueFormatter: (params: ValueFormatterParams) => {
        return (Math.round((params.value + Number.EPSILON) * 100) / 100).toString();
      },
      filter: false,
      floatingFilter: false
    },
    {
      field: 'valueWithTax',
      valueFormatter: (params: ValueFormatterParams) => {
        return (Math.round((params.value + Number.EPSILON) * 100) / 100).toString();
      },
      filter: false,
      floatingFilter: false
    }
  ];
}
